import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class TableStateClearGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    Object.entries(localStorage)
      .map(x => x[0])
      .filter(x => x.startsWith('table_'))
      .forEach(x => localStorage.removeItem(x));
    return true;
  }
}
